/**
 * @author Code Lai（赖传峰）
 * @email codelai@staritgp.com
 * @date 2018/3/22 19:39
 */
export { default } from './src/NotFound'
